import moment from "moment";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  BODY_MAP_INITIALIZATION,
  GET_BODY_PARTS,
  GET_BODY_SYMPTOM,
  IS_UNSAVED,
} from "../actions/constant";
import i18n from "../i18n";
const initialState = {
  isLoading: false,
  bodySymptoms: {},
};

function reducer(state = initialState, action) {
  function unsavedDataChecker(type, pageName) {
    let vAlertMessages = {
      title: i18n.t("bodyMap.UNSAVED_BM_DATA_TITLE", { pageName }),
      text: i18n.t("bodyMap.UNSAVED_BM_DATA_TEXT", { pageName }),
      positiveBtnText: i18n.t("bodyMap.SWITCH"),
      page: "bodyMap",
    };
    if (type === "yes") {
      IS_UNSAVED("yes");
      localStorage.setItem("unsavedAlertData", JSON.stringify(vAlertMessages));
    } else {
      IS_UNSAVED();
      localStorage.removeItem("unsavedAlertData");
    }
  }
  switch (action.type) {
    case getStarted(BODY_MAP_INITIALIZATION):
      localStorage.removeItem("bodyMapSymptom");
      let previousPageIsDirty = sessionStorage.getItem("previousPageIsDirty");
      if (previousPageIsDirty === "null" || previousPageIsDirty === null) {
        unsavedDataChecker();
      } else {
        let pageName =
          previousPageIsDirty === "input"
            ? i18n.t("menu.INPUT")
            : previousPageIsDirty === "edit"
              ? i18n.t("general.EDIT")
              : previousPageIsDirty === "createRegimen"
                ? i18n.t("recipe.CREATE_REGIMEN_PAGE_TITLE")
                : i18n.t("recipe.EDIT_REGIMEN_PAGE_TITLE")
        setTimeout(() => unsavedDataChecker("yes", pageName), 500);
      }

      return initialState;
    case getSucceeded(BODY_MAP_INITIALIZATION):
      return { ...state };
    case getFailed(BODY_MAP_INITIALIZATION):
      return { ...state };
    case getEnded(BODY_MAP_INITIALIZATION):
      return { ...state };
    case getStarted(GET_BODY_PARTS):
      state.bodySymptoms = {};
      return { ...state, isLoading: true };
    case getSucceeded(GET_BODY_PARTS):
      state.bodySymptoms = action.payload.bodyParts;
      return { ...state };
    case getFailed(GET_BODY_PARTS):
      alert(action.payload.message);
      return { ...state, isLoading: false };
    case getEnded(GET_BODY_PARTS):
      return { ...state, isLoading: false };
    case getStarted(GET_BODY_SYMPTOM):
      localStorage.removeItem("bodyMapSymptom");
      return { ...state, isLoading: true };
    case getSucceeded(GET_BODY_SYMPTOM):
      let data = { ...action.payload.symptom };
      data.time = moment();

      localStorage.setItem("bodyMapSymptom", JSON.stringify(data));
      let returnPage = localStorage.getItem("bodyreturn") || "symptom";
      window.location = "/" + returnPage;
      return { ...state };
    case getFailed(GET_BODY_SYMPTOM):
      alert(action.payload.message);
      return { ...state, isLoading: false };
    case getEnded(GET_BODY_SYMPTOM):
      return { ...state, isLoading: false };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/bodyMapReducer.js